import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class QuantidadePercentualMigracaoProdutoStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findQuantidadePercentualMigracaoProduto(filtro).then(response => {
            if (response.data) {
                this.dados = response.data.map((cargo) => ({
                    nome: cargo.cargo,
                    "Quantidade": cargo.valor
                }));
            } else {
                this.dados = [];
            }

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });

        this.carregando = false;
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
